/**
 * Mengubah string menjadi Title Case (Contoh: "gunjo aniki" -> "Gunjo Aniki")
 * @param {string} str
 * @returns {string}
 */
export const toTitleCase = (str) => {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

/**
 * Mengubah string menjadi Username format (Lowercase & hapus spasi)
 * @param {string} str
 * @returns {string}
 */
export const toSafeUsername = (str) => {
  if (!str) return "";
  return str.toLowerCase().replace(/\s+/g, "");
};

/**
 * Memformat angka ke Rupiah (Bisa Anda gunakan nanti di modul Gaji)
 */
export const formatRupiah = (angka) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(angka);
};

/**
 * Memformat menit terlambat 70 menit --> 1 Jam 10 Menit
 */
export const formatTerlambat = (totalMenit) => {
  if (!totalMenit || totalMenit <= 0) return null;
  const jam = Math.floor(totalMenit / 60);
  const menit = totalMenit % 60;
  return jam > 0 ? `${jam} Jam ${menit} Menit` : `${menit} Menit`;
};

/**
 * Memformat menit menjadi jam
 */
export const formatJam = (menit) => {
  const jam = Math.floor(menit / 60);
  const sisaMenit = menit % 60;
  if (sisaMenit === 0) return `${jam} Jam`;
  return `${jam} Jam ${sisaMenit} Menit`;
};

/**
 * Format tanggal: 2026-01-16
 * → Jum'at, 16 Januari 2026
 */
export const formatTanggalIndoLengkap = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("id-ID", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

/**
 * Format tanggal: 2026-01-16
 * → Jum'at,
 * 16 Januari 2026
 */
export const formatFullDate = (date) => {
  if (!date) return null;

  const parsedDate = new Date(date);

  return {
    dayName: parsedDate.toLocaleDateString("id-ID", {
      weekday: "long",
    }),
    date: parsedDate.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }),
  };
};

/**
 * Format nominal: 1000000
 * → 1.000.000
 */
// Format angka dengan pemisah ribuan berupa titik
export const formatRupiahNumber = (value) => {
  const angka = String(value ?? "").replace(/\D/g, "");

  return angka.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

// Membersihkan format agar hanya menyimpan angka
export const parseRupiahNumber = (value) => {
  return String(value ?? "").replace(/\D/g, "");
};
